<script setup lang="ts">
import BaseAutoCompleteWithSingleSelectedItem from "@/components/AutoCompletes/BaseAutoCompleteWithSingleSelectedItem.vue"
import organizationType from "@/types/requests/organizationType"
import FormRow from "@/components/Common/FormRow.vue"
import getRole from "@/types/responses/getRole"
import { computed } from "vue"
import i18n from "@/lang/i18n"

const emit = defineEmits(['update:modelValue'])

type searchItemsType = {
  organization: {
    id: number,
    name: string,
    type: string
  } | null,
  userName: string
}

const props = defineProps<{
  selectedRole: getRole | null
  modelValue: searchItemsType
  windowInnerWidth: number
  filter: () => void
  organizations: organizationType[]
  errorMessages: {
    organization: string[],
    roleType: string[],
    userSearchOrganization: string[]
  }
  loading: boolean
}>()

const modelValue = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    emit("update:modelValue", value)
  }
})

</script>
<template>
  <FormRow
    :title="i18n.global.t('pages.roleAssignment.form.search.title')"
    :windowInnerWidth="props.windowInnerWidth"
  >
    <div style="width: 40%">
      <div
        class="d-flex mb-4"
      >
        <div class="mr-10 mt-4">
          <h6>
            {{ i18n.global.t('pages.roleAssignment.form.search.organization') }}<span style="color: red">✴︎</span>
          </h6>
        </div>
        <BaseAutoCompleteWithSingleSelectedItem
          v-model="modelValue.organization"
          :items="props.organizations"
          itemName="name"
          :errorMessages="props.errorMessages.userSearchOrganization"
        />
      </div>
      <div class="d-flex">
        <div class="mr-7 mt-4">
          <h6>
            {{ i18n.global.t('pages.roleAssignment.form.search.userName') }}
          </h6>
        </div>
        <v-text-field
          v-model="modelValue.userName"
          outlined
          dense
          class="mt-2"
        />
      </div>
      <div class="d-flex justify-end mt-3">
        <v-btn
          class="exec-btn"
          @click="props.filter"
          :loading="props.loading"
        >
          {{ i18n.global.t('pages.roleAssignment.form.search.search') }}
        </v-btn>
      </div>
    </div>
  </FormRow>
</template>
